import { render, staticRenderFns } from "./ChartRecruitmentStatement.vue?vue&type=template&id=f19faba4&scoped=true"
import script from "./ChartRecruitmentStatement.vue?vue&type=script&lang=js"
export * from "./ChartRecruitmentStatement.vue?vue&type=script&lang=js"
import style0 from "./ChartRecruitmentStatement.vue?vue&type=style&index=0&id=f19faba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19faba4",
  null
  
)

export default component.exports